import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  titlesLength: 0,
  titles: [],
  title: {},
  titleError: "",
  formError: "",
  formErrorJson: {},
};

export default function TitlesReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_TITLES:
      return { ...state, loading: action.payload };
    case actions.LOADING_TITLES_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_TITLES:
      return { ...state, saveLoading: action.payload };
    case actions.GET_TITLES:
      return {
        ...state,
        titles: action.payload.titles,
        titlesLength: action.payload.titlesLength,
      };
    case actions.GET_TITLES_BY_ID:
      return {
        ...state, title: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FORM_FAIL_JSON:
      return { ...state, formErrorJson: action.payload };
    case actions.TITLES_FAIL:
      return { ...state, titleError: action.payload };
    default:
      return state;
  }
}
